// extracted by mini-css-extract-plugin
module.exports = {"ui-button":"xrr64ZWUVv_uVi9L-kqM5","uiButton":"xrr64ZWUVv_uVi9L-kqM5"};